export const TransferIcon = () => {
  return (
    <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="64" height="64" rx="10" fill="#EBF2FC" />
      <path
        d="M33.75 39.0334H34.8333C35.9167 39.0334 36.8167 38.0668 36.8167 36.9001C36.8167 35.4501 36.3 35.1668 35.45 34.8668L33.7667 34.2834V39.0334H33.75Z"
        fill="#4F55FD"
      />
      <path
        d="M32.45 15.6668C23.25 15.7001 15.8 23.1834 15.8334 32.3834C15.8667 41.5834 23.35 49.0334 32.55 49.0001C41.75 48.9668 49.2 41.4834 49.1667 32.2834C49.1334 23.0834 41.65 15.6501 32.45 15.6668ZM36.2667 32.5001C37.5667 32.9501 39.3167 33.9168 39.3167 36.9001C39.3167 39.4668 37.3 41.5334 34.8334 41.5334H33.75V42.5001C33.75 43.1834 33.1834 43.7501 32.5 43.7501C31.8167 43.7501 31.25 43.1834 31.25 42.5001V41.5334H30.65C27.9167 41.5334 25.7 39.2334 25.7 36.4001C25.7 35.7168 26.2667 35.1501 26.95 35.1501C27.6334 35.1501 28.2 35.7168 28.2 36.4001C28.2 37.8501 29.3 39.0334 30.65 39.0334H31.25V33.4001L28.7334 32.5001C27.4334 32.0501 25.6834 31.0834 25.6834 28.1001C25.6834 25.5334 27.7 23.4668 30.1667 23.4668H31.25V22.5001C31.25 21.8168 31.8167 21.2501 32.5 21.2501C33.1834 21.2501 33.75 21.8168 33.75 22.5001V23.4668H34.35C37.0834 23.4668 39.3 25.7668 39.3 28.6001C39.3 29.2834 38.7334 29.8501 38.05 29.8501C37.3667 29.8501 36.8 29.2834 36.8 28.6001C36.8 27.1501 35.7 25.9668 34.35 25.9668H33.75V31.6001L36.2667 32.5001Z"
        fill="#4F55FD"
      />
      <path
        d="M28.2 28.1166C28.2 29.5666 28.7166 29.8499 29.5666 30.1499L31.25 30.7332V25.9666H30.1666C29.0833 25.9666 28.2 26.9332 28.2 28.1166Z"
        fill="#4F55FD"
      />
    </svg>
  );
};

export const ConvertIcon = () => {
  return (
    <svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="64" height="64" rx="10" fill="#EBF2FC" />
      <path
        d="M38.9833 15.8333H25.0166C18.9499 15.8333 15.3333 19.4499 15.3333 25.5166V39.4666C15.3333 45.5499 18.9499 49.1666 25.0166 49.1666H38.9666C45.0333 49.1666 48.6499 45.5499 48.6499 39.4833V25.5166C48.6666 19.4499 45.0499 15.8333 38.9833 15.8333ZM41.4833 35.9166C41.4166 36.0666 41.3333 36.1999 41.2166 36.3166L36.2999 41.2333C36.0499 41.4833 35.7333 41.5999 35.4166 41.5999C35.0999 41.5999 34.7833 41.4833 34.5333 41.2333C34.0499 40.7499 34.0499 39.9499 34.5333 39.4666L37.3166 36.6833H23.6666C22.9833 36.6833 22.4166 36.1166 22.4166 35.4333C22.4166 34.7499 22.9833 34.1833 23.6666 34.1833H40.3333C40.4999 34.1833 40.6499 34.2166 40.8166 34.2833C41.1166 34.4166 41.3666 34.6499 41.4999 34.9666C41.6166 35.2666 41.6166 35.5999 41.4833 35.9166ZM40.3333 30.8166H23.6666C23.4999 30.8166 23.3499 30.7833 23.1833 30.7166C22.8833 30.5833 22.6333 30.3499 22.4999 30.0333C22.3666 29.7333 22.3666 29.3833 22.4999 29.0833C22.5833 28.9333 22.6666 28.7999 22.7833 28.6833L27.6999 23.7666C28.1833 23.2833 28.9833 23.2833 29.4666 23.7666C29.9499 24.2499 29.9499 25.0499 29.4666 25.5333L26.6833 28.3166H40.3333C41.0166 28.3166 41.5833 28.8833 41.5833 29.5666C41.5833 30.2499 41.0166 30.8166 40.3333 30.8166Z"
        fill="#4F55FD"
      />
    </svg>
  );
};

export const EmptyTransactionsIllustration = () => (
  <svg width="265" height="136" viewBox="0 0 265 136" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="264.893" height="208.798" rx="12" fill="url(#paint0_linear_285_8536)" />
    <rect x="20" y="20" width="20" height="20" rx="4" fill="#FDFDFD" />
    <rect x="48" y="20" width="197" height="20" rx="4" fill="#FDFDFD" />
    <rect x="20" y="50" width="225" height="93" rx="8" fill="url(#paint1_linear_285_8536)" />
    <rect x="32" y="62" width="95" height="14" rx="4" fill="#E8F0FC" />
    <rect x="32" y="84.493" width="55.5048" height="11.8098" rx="4" fill="#E8F0FC" />
    <defs>
      <linearGradient
        id="paint0_linear_285_8536"
        x1="132.447"
        y1="-1.57815e-06"
        x2="111.576"
        y2="136.616"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3F8FF" />
        <stop offset="1" stopColor="#F1F7FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_285_8536"
        x1="132.5"
        y1="50"
        x2="132.5"
        y2="143"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFDFD" />
        <stop offset="1" stopColor="#F1F7FF" />
      </linearGradient>
    </defs>
  </svg>
);

export const AddFundsIcon = () => {
  return (
    <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="64" height="64" rx="10" fill="#EBF2FC" />
      <path
        d="M40.8333 19.1667H24.1666C19.1666 19.1667 15.8333 21.6667 15.8333 27.5001V33.4334C15.8333 34.0501 16.4666 34.4334 17.0166 34.1834C18.6499 33.4334 20.5333 33.1501 22.5166 33.5001C26.8999 34.2834 30.1166 38.3501 29.9999 42.8001C29.9833 43.5001 29.8833 44.1834 29.6999 44.8501C29.5666 45.3667 29.9833 45.8501 30.5166 45.8501H40.8333C45.8333 45.8501 49.1666 43.3501 49.1666 37.5167V27.5001C49.1666 21.6667 45.8333 19.1667 40.8333 19.1667ZM32.4999 36.6667C30.1999 36.6667 28.3333 34.8001 28.3333 32.5001C28.3333 30.2001 30.1999 28.3334 32.4999 28.3334C34.7999 28.3334 36.6666 30.2001 36.6666 32.5001C36.6666 34.8001 34.7999 36.6667 32.4999 36.6667ZM44.5833 35.8334C44.5833 36.5167 44.0166 37.0834 43.3333 37.0834C42.6499 37.0834 42.0833 36.5167 42.0833 35.8334V29.1667C42.0833 28.4834 42.6499 27.9167 43.3333 27.9167C44.0166 27.9167 44.5833 28.4834 44.5833 29.1667V35.8334Z"
        fill="#4F55FD"
      />
      <path
        d="M20.8334 35.8333C17.1501 35.8333 14.1667 38.8166 14.1667 42.4999C14.1667 43.7499 14.5167 44.9333 15.1334 45.9333C16.2834 47.8666 18.4001 49.1666 20.8334 49.1666C23.2667 49.1666 25.3834 47.8666 26.5334 45.9333C27.1501 44.9333 27.5001 43.7499 27.5001 42.4999C27.5001 38.8166 24.5167 35.8333 20.8334 35.8333ZM23.3167 43.7166H22.0834V45.0166C22.0834 45.6999 21.5167 46.2666 20.8334 46.2666C20.1501 46.2666 19.5834 45.6999 19.5834 45.0166V43.7166H18.3501C17.6667 43.7166 17.1001 43.1499 17.1001 42.4666C17.1001 41.7833 17.6667 41.2166 18.3501 41.2166H19.5834V40.0333C19.5834 39.3499 20.1501 38.7833 20.8334 38.7833C21.5167 38.7833 22.0834 39.3499 22.0834 40.0333V41.2166H23.3167C24.0001 41.2166 24.5667 41.7833 24.5667 42.4666C24.5667 43.1499 24.0167 43.7166 23.3167 43.7166Z"
        fill="#4F55FD"
      />
    </svg>
  );
};
